import ScoreSummary from "./ScoreSummary";
export default ScoreSummary;
